import { action } from 'satcheljs/lib/legacy';
import {
    AttachmentFileInformation,
    BaseFileInformation,
    FileType,
    SharePointFileInformation,
} from 'owa-group-files-hub-store';
import prefetchAttachmentFilePreviewInformation from './prefetchAttachmentFilePreviewInformation';
import prefetchSharePointFilePreviewInformation from './prefetchSharePointFilePreviewInformation';

export default action('prefetchFilePreviewInformationAction')((fileList: BaseFileInformation[]) => {
    if (fileList && fileList.length > 0) {
        const attachmentList: AttachmentFileInformation[] = [];

        for (let file of fileList) {
            switch (file.fileType) {
                case FileType.ClassicAttachment:
                case FileType.CloudAttachment:
                    attachmentList.push(file as AttachmentFileInformation);
                    break;
                case FileType.SharePointFile:
                    prefetchSharePointFilePreviewInformation(file as SharePointFileInformation);
                    break;
            }
        }

        if (attachmentList.length > 0) {
            prefetchAttachmentFilePreviewInformation(attachmentList);
        }
    }
});
